// Fragmento de un resultado de busqueda: las palabras entre « » se resaltan (texto de React, sin HTML).
export function Fragmento({ texto }: { texto: string }) {
  return <>{texto.split(/(«[^»]*»)/).map((p, i) => (p.startsWith('«') && p.endsWith('»') ? <mark key={i}>{p.slice(1, -1)}</mark> : p))}</>;
}
